import { render, staticRenderFns } from "./CModalAddRequirement.vue?vue&type=template&id=5cfae924&scoped=true"
import script from "./CModalAddRequirement.vue?vue&type=script&lang=js"
export * from "./CModalAddRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfae924",
  null
  
)

export default component.exports